import { render, staticRenderFns } from "./ApplicationsDetailsPayments.vue?vue&type=template&id=dd00242c&scoped=true"
import script from "./ApplicationsDetailsPayments.vue?vue&type=script&lang=js"
export * from "./ApplicationsDetailsPayments.vue?vue&type=script&lang=js"
import style0 from "./ApplicationsDetailsPayments.vue?vue&type=style&index=0&id=dd00242c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd00242c",
  null
  
)

export default component.exports